import { render, staticRenderFns } from "./barcodeScanner.vue?vue&type=template&id=07fc7142&scoped=true"
import script from "./barcodeScanner.vue?vue&type=script&lang=js"
export * from "./barcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./barcodeScanner.vue?vue&type=style&index=0&id=07fc7142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc7142",
  null
  
)

export default component.exports